import { render, staticRenderFns } from "./detailPage1.vue?vue&type=template&id=81e84f82&scoped=true"
import script from "./detailPage1.vue?vue&type=script&lang=js"
export * from "./detailPage1.vue?vue&type=script&lang=js"
import style0 from "./detailPage1.vue?vue&type=style&index=0&id=81e84f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e84f82",
  null
  
)

export default component.exports